<div (click)="onClick()" class="wrapper">
  <div [title]="btnTitle" class="map-control-btn" [ngClass]="{'btn-label': showLabel }">
    <i class="material-symbols-outlined traffic-icon" [ngClass]="{'selected' : trafficLayerActive}">traffic</i>
    <span *ngIf="showLabel">{{ btnTitle }}</span>
  </div>
</div>
